import React from "react";
import { Typography, Row, Col } from "antd";
import { useLocation } from "react-router-dom";

import Spinner from "../Spinner";
import { usePosts } from "../../custom-hooks/";
import { Layout } from "antd";
import PostCard from "./PostCard";
import Sidebar from "../root/Sidebar";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function Posts() {
  const location = useLocation();

  const [posts, isLoading] = usePosts(location.pathname.replace("/", ""));

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Layout>
      <Layout>
        <Content style={{ padding: "24px" }}>
          <Title level={2}>Articles</Title>
          <Row gutter={[16, 16]} className="posts">
            {posts.length === 0 ? (
              <Col>
                <Paragraph>Coming soon!</Paragraph>
              </Col>
            ) : (
              posts.map((post) => (
                <PostCard post={post} key={post.fields.slug} />
              ))
            )}
          </Row>
        </Content>
      </Layout>
      <Sidebar />
    </Layout>
  );
}
